/**
 * @fileoverview Shared constants for integration cards.
 * @module features/settings/components/integration-shared/constants
 */

import type { IntegrationProvider, IntegrationStatusType } from '../../schemas/integrationStatusSchema'

/** Status badge variant configuration */
export const STATUS_BADGE_VARIANTS: Record<IntegrationStatusType, 'default' | 'secondary' | 'destructive' | 'outline'> = {
  ACTIVE: 'default',
  ERROR: 'destructive',
  EXPIRED: 'outline',
  NOT_CONFIGURED: 'secondary',
}

/** Status badge translation keys */
export const STATUS_LABEL_KEYS: Record<IntegrationStatusType, string> = {
  ACTIVE: 'cards.integrations.status.active',
  ERROR: 'cards.integrations.status.error',
  EXPIRED: 'cards.integrations.status.expired',
  NOT_CONFIGURED: 'cards.integrations.status.notConfigured',
}

/** Provider display names */
export const PROVIDER_NAMES: Record<IntegrationProvider, string> = {
  FACEBOOK: 'Facebook Ads',
  GOOGLE_ADS: 'Google Ads',
  BASELINKER: 'BaseLinker',
  SHOPIFY: 'Shopify',
  BANK: 'Bank',
}

/** Provider icon paths */
export const PROVIDER_ICONS: Record<IntegrationProvider, string> = {
  FACEBOOK: '/meta-favicon.png',
  GOOGLE_ADS: '/google-favicon.png',
  BASELINKER: '/base-favicon.png',
  SHOPIFY: '/shopify.webp',
  BANK: '',
}

/** Sync endpoint URLs by provider */
export const SYNC_URLS: Record<'FACEBOOK' | 'GOOGLE_ADS', string> = {
  GOOGLE_ADS: '/admin/google-ads/sync/range',
  FACEBOOK: '/admin/facebook/sync/range',
}

/** Manual sync job status endpoint URLs by provider */
export const SYNC_JOB_STATUS_URLS: Record<'FACEBOOK' | 'GOOGLE_ADS', string> = {
  GOOGLE_ADS: '/admin/google-ads/sync/jobs',
  FACEBOOK: '/admin/facebook/sync/jobs',
}
